//
// 下拉框
// ============================================================

import DropdownPublic from "./dropdown-public";

const Select = options => DropdownPublic(options);

module.exports = Select;


// WEBPACK FOOTER //
// src/js/select.js